import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule, Routes } from '@angular/router';
import { UserDetailsCardModule } from 'app/library/shared/user-details-card/user-details-card.module';
import { TeamLeadersResolver } from 'app/library/team/services/team-leaders.resolver';
import { TeamMembersResolver } from 'app/library/team/services/team-members.resolver';
import { TeamSubTeamsResolver } from 'app/library/team/services/team-subteams.resolver';
import { TeamWatchersResolver } from 'app/library/team/services/team-watchers.resolver';
import { TeamGuard } from 'app/library/team/services/team.guard';
import { TeamResolver } from 'app/library/team/services/team.resolver';
import { UserOtherTeamsResolver } from 'app/library/team/services/user-other-teams.resolver';
import { UserProgressResolver } from 'app/library/team/services/user-progress.resolver';
import { UserTeamGuard } from 'app/library/team/services/user-team.guard';
import { TeamModule } from 'app/library/team/team.module';
import { MaxBrainNavigationItemModule } from 'app/navigation/components/item/item.module';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { NgChartsModule } from 'ng2-charts';
import { ActiveDaysComponent } from './active-days/active-days.component';
import { AddUserToTeamDialogComponent } from './dialogs/add-user-to-team-dialog/add-user-to-team-dialog.component';
import { SelectTeamsDialogComponent } from './dialogs/select-teams-dialog/select-teams-dialog.component';
import { TeamCardComponent } from './team-card/team-card.component';
import { TeamLeadersComponent } from './team-leaders/team-leaders.component';
import { TeamMembersComponent } from './team-members/team-members.component';
import { TeamPageComponent } from './team-page/team-page.component';
import { TeamComponent } from './team-page/team/team.component';
import { TeamTrainingResponsiblesComponent } from './team-training-responsibles/team-training-responsibles.component';
import { TeamSubteamsComponent } from './team-subteams/team-subteams.component';
import { TeamsSearchComponent } from './teams-search/teams-search.component';
import { AdminTeamsWriteGuard } from './admin-teams-write.guard';

const routes: Routes = [
    {
        path: 'edit',
        children: [
            {
                path: 'search',
                component: TeamsSearchComponent,
            },
            {
                path: ':teamId',
                component: TeamPageComponent,
                resolve: { isFetched: TeamResolver, isFetched2: TeamMembersResolver, isFetched3: TeamLeadersResolver, isFetched4: TeamWatchersResolver },
            },
            {
                path: '**',
                redirectTo: 'search',
            },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        MaxBrainSharedModule,
        MaxBrainNavigationItemModule,

        MatMenuModule,
        MatListModule,
        MatSnackBarModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatSidenavModule,
        MatCardModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        NgChartsModule,
        MatTableModule,
        MatTreeModule,
        UserDetailsCardModule,
        TeamModule,
    ],
    declarations: [
        TeamPageComponent,
        TeamComponent,
        TeamsSearchComponent,
        TeamLeadersComponent,
        TeamTrainingResponsiblesComponent,
        TeamMembersComponent,
        ActiveDaysComponent,
        TeamCardComponent,
        TeamSubteamsComponent,
        AddUserToTeamDialogComponent,
        SelectTeamsDialogComponent,
    ],
    providers: [
        TeamResolver,
        TeamMembersResolver,
        TeamLeadersResolver,
        TeamWatchersResolver,
        TeamSubTeamsResolver,
        UserProgressResolver,
        UserOtherTeamsResolver,
        UserTeamGuard,
        TeamGuard,
        AdminTeamsWriteGuard,
    ],
    exports: [TeamComponent, TeamCardComponent, ActiveDaysComponent, TeamSubteamsComponent, AddUserToTeamDialogComponent, SelectTeamsDialogComponent],
})
export class TeamsModule {}
